import styles from './MonthSelectBox.css'
import moment from 'moment'

class MonthSelectBox extends React.Component {
  render () {
    return (<div className={!this.props.fullSiteMode ? styles.wrapper : styles['wrap-full-site']}>
      <div className='row'>
        <div className='col-md-12'>
          <table className={styles.table} cellSpacing='0'>
            <thead>
              <tr>
                <td>
                  <button className={`btn btn-default ${styles['btn']}`} onClick={() => this._previousMonth()}>
                    <span className='fa fa-angle-left' />
                  </button>
                </td>
                <td colSpan='5'>
                  <span className={styles.month}>{this._monthLabel()}</span>&nbsp;<span className={styles.year}>{this._yearLabel()}</span>
                </td>
                <td>
                  <button className={`btn btn-default ${styles['btn']}`} onClick={() => this._nextMonth()}>
                    <span className='fa fa-angle-right' />
                  </button>
                </td>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>)
  }

  _previousMonth = () => {
    let {year, month} = this.props
    let newDate = moment({year, month}).add(-1, 'months')
    this.props.onChange({
      year: newDate.year(),
      month: newDate.month()
    })
  };

  _nextMonth = () => {
    let {year, month} = this.props
    let newDate = moment({year, month}).add(1, 'months')
    this.props.onChange({
      year: newDate.year(),
      month: newDate.month()
    })
  };

  _monthLabel = () => {
    let {year, month} = this.props
    return moment({year, month}).format('MMMM')
  }

  _yearLabel = () => {
    let {year, month} = this.props
    return moment({year, month}).format('YYYY')
  }
}

MonthSelectBox.propTypes = {
  year: React.PropTypes.number,
  month: React.PropTypes.number
}
export default MonthSelectBox



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownCalendarPromo/MonthSelectBox/MonthSelectBox.js